import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import s from './ApproveProposalsModal.scss'
import { Checkbox } from 'components/ideal-core-ui'
import { FaExclamationCircle } from 'react-icons/fa'

const SendForInternalReviewModal = ({
  showApproveProposalsModal,
  toggleApproveProposalsModal,
  proposals,
  toggleSelectProposal,
  size = 'md',
  selectedProposals,
  approveProposals
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showApproveProposalsModal}
        toggle={toggleApproveProposalsModal}
        size={size}
      >
        <ModalBody className={s.modalBody}>
          <FaExclamationCircle className={s.exclamationMark} />
          <p className={s.title}>You are about to approve the following Proposal(s).</p>
          <i className={s.subtitle}>(Un-check the ones that you don&#39;t want to approve)</i>
          {proposals?.length > 0 && (
            <div className={s.proposalsWrapper}>
              {proposals.map(proposal => (
                <div key={proposal.id}>
                  <Checkbox
                    isChecked={selectedProposals.includes(proposal.id)}
                    triggerCheckbox={() => toggleSelectProposal(proposal.id)}
                  />
                  <span>{proposal.name}</span>
                </div>
              ))}
            </div>
          )}
          <p className={s.title}>Are you sure you want to continue?</p>
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            disabled={!selectedProposals.length}
            onClick={approveProposals}
          >
            Yes
          </Button>
          <Button color="secondary" onClick={toggleApproveProposalsModal}>
            No
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default SendForInternalReviewModal
